module.exports = __webpack_public_path__ + "img/password_tip_area.8bfecc6d.svg";